import { render, staticRenderFns } from "./ElementarySchoolMathCourse.vue?vue&type=template&id=56bcc66a&scoped=true&"
import script from "./ElementarySchoolMathCourse.vue?vue&type=script&lang=js&"
export * from "./ElementarySchoolMathCourse.vue?vue&type=script&lang=js&"
import style0 from "./ElementarySchoolMathCourse.vue?vue&type=style&index=0&id=56bcc66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bcc66a",
  null
  
)

export default component.exports